exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "\n.confirmation-dialog .modal-dialog {\n    top: 25% !important;\n}\n.btn-confirmation {\n    width: 85px;\n}\n.general-nofi-modal-msg {\n    margin-top: 25px;\n    margin-bottom: -3px;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-rewriter.js?id=data-v-3a739620!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./components/v-components/confirmation-dialog.vue
// module id = 176
// module chunks = 0 1 2 3 4 5 6 7 8 10 11 12 13 14 17 18 19 20 21 24 25 26 27 28 34 35